export const environment = 
{
    production: false,
    BASE_URL: "https://api.preprodpartenaires.mediation-eau.fr",
    HOST_SITE : "preprod.partenaires.mediation-eau.fr",
    ALLOWED_DOMAINS: ["preprod.partenaires.mediation-eau.fr"],
    LINK_GUIDE : "https://preprod.mediation-eau.fr/userfiles/files/guide/MDE_GuideUtilisation_EspacePartenaires.pdf",
    URL_SITE : "https://preprod.mediation-eau.fr"
}